import _ from 'lodash';
import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { renderNoRoutesMessage } from '../services/TimetablesService';
import { createSearchModeBoundActions } from '../utils/ReduxUtils';

/* ------------- Types and Action Creators ------------- */
// init() is a function that expects searchMode as a parameter and returns action creators as defined here
// (see createTimetablesActions javadoc for more info)
const { Types, init: initActionCreators } = createSearchModeBoundActions({
  setQuery: ['query'],
  fetchRecentSearches: ['query', 'baseStorageKey'],
  fetchRecentSearchesSuccess: ['suggestions'],
  fetchSuggestions: ['query'],
  fetchSuggestionsSuccess: ['query', 'suggestions'],
  fetchSuggestionsError: ['error', 'suggestionError'],
  selectSuggestion: ['selected', 'baseStorageKey'],
  clearSuggestions: [],
  resetSearch: [],
});

export default initActionCreators;
export const RouteAutosuggestTypes = Types;

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  query: '',
  selection: null,
  suggestions: [],
  suggestionError: null,
  fetching: false,
});

/* ------------- Reducers ------------- */

const setQueryHandler = (state, { query }) => state.merge({
  query,
});

const fetchRecentSearchesSuccessHandler = (state, { suggestions }) => state.merge({
  suggestions,
});

const fetchSuggestionsHandler = state => state.merge({
  fetching: true,
});

const fetchSuggestionsSuccessHandler = (state, { query, suggestions: suggestionsRemote }) => {
  const { query: latestQuery, suggestions: suggestionsLocal } = state;
  if (query === latestQuery) {
    // suggestions can already contain recent searches (see fetchRecentSearchesSuccessHandler),
    // therefore we merge them instead of replacing (equality function is a lambda that compare route short name and headsign)
    const suggestions = _.unionWith(suggestionsLocal, suggestionsRemote, (a, b) => a.route_short_name === b.route_short_name && a.last_stop_headsign === b.last_stop_headsign);
    return state.merge({
      suggestions: (!_.isEmpty(query) && suggestions.length === 0) ? [renderNoRoutesMessage(query)] : suggestions,
      suggestionError: null,
      fetching: false,
    });
  }
  return state;
};

const fetchSuggestionsErrorHandler = (state, { error }) => state.merge({
  suggestions: [],
  suggestionError: error,
  fetching: false,
});

const clearSuggestionsHandler = state => state.merge({
  suggestions: [],
});

const selectSuggestionHandler = (state, { selected }) => state.merge({
  selection: selected,
  fetching: false,
  suggestions: [],
  suggestionError: null,
});

const resetSearchHandler = state => state.merge({
  query: '',
  selection: null,
  suggestions: [],
});

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_QUERY]: setQueryHandler,
  [Types.FETCH_RECENT_SEARCHES_SUCCESS]: fetchRecentSearchesSuccessHandler,
  [Types.FETCH_SUGGESTIONS]: fetchSuggestionsHandler,
  [Types.FETCH_SUGGESTIONS_SUCCESS]: fetchSuggestionsSuccessHandler,
  [Types.FETCH_SUGGESTIONS_ERROR]: fetchSuggestionsErrorHandler,
  [Types.SELECT_SUGGESTION]: selectSuggestionHandler,
  [Types.CLEAR_SUGGESTIONS]: clearSuggestionsHandler,
  [Types.RESET_SEARCH]: resetSearchHandler,
});
